// extracted by mini-css-extract-plugin
module.exports = {"page":"profile-page_page__2Uedm","pageContent":"profile-page_pageContent__2Ma0v","main":"profile-page_main__3bNoQ","mainContent":"profile-page_mainContent__1zAzX"};